import { useTranslation } from 'react-i18next';

import { IPatientsNameRowProps } from './types';

export const PatientsNameRow = ({ patient }: IPatientsNameRowProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center">
      <div
        className="flex typography-inline-highlight-3 text-text-primary pr-4"
        style={{ wordBreak: 'break-word' }}
      >{`${patient.lastName.toUpperCase()}, ${patient.firstName}`}</div>
      {patient.newUser && (
        <div className="flex items-center h-[24px] bg-global-neuchatel-50 typography-inline-highlight-3 text-text-primaryInverse rounded-xl px-2">
          {t('patients.label.new')}
        </div>
      )}
    </div>
  );
};
